import React from 'react'
import PropTypes from 'prop-types'

import { createUseStyles, useTheme } from 'react-jss'

let useStyles = createUseStyles({
  bookingWidgetWrapper: ({ bgColor, theme }) => ({
    //backgroundColor: bgColor || theme.colors.blue,
    backgroundColor: theme.colors.red,
    maxHeight: 700,
    margin: '50px 0 0',
    padding: 0,

    '&.is-closed': {
      display: 'none',
    },
    '& .con': {
      '@media (max-width: 900px)': {
        maxWidth: 400,
      },
    },
    '& > div': {
      ...theme.wrappers.standard,
      display: 'flex',
      flexWrap: 'nowrap',
      paddingBottom: 25,
      paddingTop: 7,
      width: '100%',
      justifyContent: 'space-between',
      // "@media (max-width: 1200px)": {
      '@media (max-width: 1400px)': {
        flexWrap: 'wrap',
        justifyContent: 'unset',
      },
    },
    '& .react-datepicker-popper': {
      zIndex: '100 !important',
    },
    '& .select__menu': {
      zIndex: '100 !important',
    },
  }),
})

export const BookingWidget = ({ bgColor, widgetOpen, widgetLocked, children }) => {
  const theme = useTheme()
  const classes = useStyles({ bgColor, theme })
  const isLoading = false
  const isDisabled = false

  return (
    <div
      id={'formBook'}
      className={`${classes.bookingWidgetWrapper} ${widgetOpen ? '' : 'is-closed'}`}
    >
      <div className="con">{children}</div>
    </div>
  )
}

BookingWidget.propTypes = {}

export default BookingWidget
